export default "__VITE_ASSET__Bb$wpq9I__"